/**
 * TemplateSkeleton — renders a template's `blocks` as a faux email preview.
 * Used both as the gallery card thumbnail (compact) and inside the preview
 * drawer (full). Purely visual, token-driven so it adapts to light/dark.
 */
export default function TemplateSkeleton({ blocks = [], accent = "var(--color-primary)", compact = false }) {
  const gap = compact ? "gap-1.5" : "gap-2.5";
  const pad = compact ? "p-2.5" : "p-4";

  const Bar = ({ h, w = "100%", color = "var(--color-surface-alt)", rounded = "rounded" }) => (
    <div className={rounded} style={{ height: h, width: w, background: color }} />
  );

  const render = (b, i) => {
    switch (b.type) {
      case "hero":
        return <Bar key={i} h={compact ? 26 : 56} color={accent} rounded="rounded-lg" />;
      case "image":
        return <Bar key={i} h={compact ? 22 : 48} color="var(--color-border)" rounded="rounded-lg" />;
      case "button":
        return <Bar key={i} h={compact ? 10 : 18} w={b.w} color={accent} rounded="rounded-full" />;
      case "badge":
        return <Bar key={i} h={compact ? 7 : 12} w={b.w} color={accent} rounded="rounded-full" />;
      case "divider":
        return <Bar key={i} h={1} color="var(--color-border)" />;
      case "list":
        return (
          <div key={i} className={`flex flex-col ${compact ? "gap-1" : "gap-1.5"}`}>
            {[90, 80, 70].map((w) => <Bar key={w} h={compact ? 5 : 8} w={`${w}%`} />)}
          </div>
        );
      case "cols3":
        return (
          <div key={i} className="flex gap-1.5">
            {[0, 1, 2].map((c) => <Bar key={c} h={compact ? 18 : 36} rounded="rounded-md" />)}
          </div>
        );
      default: // text
        return <Bar key={i} h={compact ? 6 : 9} w={b.w} />;
    }
  };

  return (
    <div className={`w-full bg-surface border border-border rounded-lg ${pad} flex flex-col ${gap}`}>
      {blocks.map(render)}
    </div>
  );
}
